import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BulkVehicleLinkComponent } from './bulk-vehicle-link/bulk-vehicle-link.component';
import { BulkVehicleLandingComponent } from './bulk-vehicle-landing/bulk-vehicle-landing.component';

const routes: Routes = [
  {path:'',component:BulkVehicleLinkComponent,
    children:[
      {path:'printBulkBuildingVehicleQRDetail',component:BulkVehicleLandingComponent}
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PrintBulkVehicleRoutingModule { }
